import { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router";
import { motion, AnimatePresence } from 'motion/react';
import { Sparkles, X } from 'lucide-react';

/**
 * Sticky floating "Get a Free Quote" button.
 * - Appears after the user scrolls 300px
 * - Hidden on /quote and /es/cotizacion (already on the form)
 * - Dismissible per session
 * - Adapts label to Spanish pages
 */
export default function FloatingQuoteCTA() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const location = useLocation();
  const isSpanish = location.pathname.startsWith('/es');
  const isQuotePage = location.pathname === '/quote' || location.pathname === '/es/cotizacion';
  useEffect(() => {
    if (isQuotePage || dismissed) return;
    const onScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [isQuotePage, dismissed]);
  if (isQuotePage || dismissed) return null;
  return <AnimatePresence>
      {visible && <motion.div className="fixed bottom-6 right-4 sm:right-6 z-50 flex items-center gap-2" initial={{
      opacity: 0,
      y: 24,
      scale: 0.92
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 24,
      scale: 0.92
    }} transition={{
      duration: 0.3,
      ease: 'easeOut' as const
    }}>
          <Link to={isSpanish ? '/es/cotizacion' : '/quote'} className="floating-cta-btn flex items-center gap-2 px-5 py-3 rounded-full font-bold text-sm shadow-2xl transition-all duration-200 hover:scale-105 active:scale-95" aria-label={isSpanish ? 'Obtener cotización gratis' : 'Get a free quote'}>
            <Sparkles size={15} aria-hidden="true" />
            {isSpanish ? 'Cotización Gratis' : 'Get a Free Quote'}
          </Link>
          <button onClick={() => setDismissed(true)} className="floating-cta-dismiss w-7 h-7 rounded-full flex items-center justify-center transition-colors duration-150" aria-label="Dismiss">
            <X size={13} aria-hidden="true" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}
